import { useEffect } from "react";

import { ParceirosFooter } from "@/components/parceiros/ParceirosFooter";
import { SelecaoHeader } from "@/components/selecao/SelecaoHeader";
import { SelecaoHero } from "@/components/selecao/SelecaoHero";
import { SelecaoEscritorio } from "@/components/selecao/SelecaoEscritorio";
import { SelecaoDepoimentosInvestidor } from "@/components/selecao/SelecaoDepoimentosInvestidor";
import { SelecaoDepoimentosAssessor } from "@/components/selecao/SelecaoDepoimentosAssessor";
import { SelecaoComoFunciona } from "@/components/selecao/SelecaoComoFunciona";
import { SelecaoFAQ } from "@/components/selecao/SelecaoFAQ";
import { SelecaoCTAFinal } from "@/components/selecao/SelecaoCTAFinal";
import { SelecaoStickyCTA } from "@/components/selecao/SelecaoStickyCTA";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Allu — Encontro Exclusivo para Assessores Certificados";
const PAGE_DESC =
  "Live de 60 minutos sobre o programa de parceiros da Allu. Entenda 100% como funciona o crédito estruturado securitizado. Sem replay.";

const Selecao = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#112711]"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <SelecaoHeader />

      <main className="pb-20 md:pb-0">
        <SelecaoHero />
        <SelecaoDepoimentosAssessor />
        <SelecaoDepoimentosInvestidor />
        <SelecaoEscritorio />
        <SelecaoComoFunciona />
        <SelecaoFAQ />
        <SelecaoCTAFinal />
      </main>

      <SelecaoStickyCTA />
      <ParceirosFooter />
    </div>
  );
};

export default Selecao;
